// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".author,.author__link{align-items:center;display:flex;justify-content:center}.author__image{border:2px solid #fff;border-radius:100%;height:40px;margin-right:5px;overflow:hidden;width:40px}.author__name{color:#fff;font-size:.875rem;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
